import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import {  useLocation } from "react-router-dom";
import * as Template from "../../templates";

export default () => {
  const moduleName = "attribute_items";
  const location = useLocation()
  const appReducer = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const handleDelete = id => dispatch(actions.destroy(id, moduleName))

  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
  }, [appReducer.attribute_items_destroy, location.search]);

  useEffect(() => {
    if (appReducer.attribute_items_list != undefined) {
      setRows(appReducer.attribute_items_list.data)
      setTotalPages(appReducer.attribute_items_list.count)
    }
  }, [appReducer])


  const columns = [
    {
      name: 'نام',
      selector: row => row.name,
    },
    {
      name: 'ویژگی',
      selector: row => row.attribute.name,
    },
    {
      name: 'وضعیت',
      selector: row => <Template.State variant={row.state} />,
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      selector: row => <div className="flex items-center gap-2">
        <Template.TableButton handleDelete={() => handleDelete(row.id)} row={row} location={location} />
      </div>,
    },
  ];

  return <Template.Table count={totalPages} columns={columns} data={rows} />;

};